import { useMemo } from 'react';
import sortBySubscriptionId from '../helpers/sort-by-subscription-id';

const useAvailablePlans = (plans, currentPlan, disabledPlans) =>
  useMemo(() => {
    let featureList;

    const plansMeta = Object.entries(plans).reduce(
      (result, [id, planConfig]) => {
        const { name, meta = {}, features, available } = planConfig;

        if (disabledPlans.includes(id) || (!available && currentPlan !== id)) {
          return result;
        }

        if (!featureList) {
          featureList = Object.keys(features);
        }

        const planData = {
          id,
          config: features,
          name,
          meta,
        };

        return {
          plans: [...result.plans, planData],
          map: {
            ...result.map,
            [id]: planData,
          },
        };
      },
      { plans: [], map: {} }
    );

    return {
      features: featureList,
      plans: sortBySubscriptionId(plansMeta.plans),
      planIds: plansMeta.plans.map((plan) => plan.id),
      map: plansMeta.map,
    };
  }, [plans, currentPlan, disabledPlans]);

export default useAvailablePlans;
